<template>
  <div>
    <!--Banner-->
    <div class="uk-cover-container">
      <BannerComponent :banner-url="bannerUrl" :title="title"/>
    </div>

    <div class="uk-container">

      <!--Description-->
      <PropertySectionOne :description="'colombo.para_1'|translate"/>

      <!--Slider-->
      <PropertySectionTwo :slide-items="slideItems"/>

      <!--Map-->
      <PropertySectionThree
        :title="'the_location'|translate"
        :moto="title"
        :description="'colombo.para_2'|translate"
        :embedded-map-url="embeddedMapUrl"
      />

      <!--Features-->
      <PropertySectionSix :features="features"/>

      <!--Thumbnav-->
      <PropertySectionFour :slide-items="thumbNavItems"/>

      <!-- Testimonials -->
      <PropertyTestimonials :items="testimonials"/>

      <!--Packages-->
      <PropertySectionFive :packages="packages"/>

    </div>

  </div>

</template>

<script>
import BannerComponent from '../components/BannerComponent'
import PropertySectionOne from '../components/properties/PropertySectionOne'
import PropertySectionTwo from '../components/properties/PropertySectionTwo'
import PropertySectionThree from '../components/properties/PropertySectionThree'
import PropertySectionFour from '../components/properties/PropertySectionFour'
import PropertySectionFive from '../components/properties/PropertySectionFive'
import PropertySectionSix from '../components/properties/PropertySectionSix'
import PropertyTestimonials from '../components/properties/PropertyTestimonials'
import store from '../store'

export default {
  name: 'PropertyColombo',
  components: {
    BannerComponent,
    PropertySectionOne,
    PropertySectionTwo,
    PropertySectionThree,
    PropertySectionFour,
    PropertySectionFive,
    PropertySectionSix,
    PropertyTestimonials
  },
  data: function () {
    return {
      propertyId: 2,
      title: store.state.property.colombo.location,
      bannerUrl: store.state.property.colombo.bannerUrl,
      slideItems: store.state.property.colombo.slideItems,
      embeddedMapUrl: store.state.property.colombo.embeddedMapUrl,
      thumbNavItems: store.state.property.colombo.thumbNavItems,
      packages: store.state.property.colombo.packages,
      features: store.state.property.colombo.features,
      testimonials: store.state.property.colombo.testimonials
    }
  },
  mounted () {
    this.fetchPriceList()
    this.fetchDeals()
    this.fetchFoods()
  },
  methods: {
    fetchPriceList () {
      this.$store.dispatch('property/fetchPropertyPriceList', { propertyId: this.propertyId })
    },
    fetchDeals () {
      this.$store.dispatch('property/fetchPropertyDeals', { propertyId: this.propertyId })
    },
    fetchFoods () {
      this.$store.dispatch('property/fetchPropertyFoods', { propertyId: this.propertyId })
    }
  }
}
</script>

<style scoped>

</style>
